/*
 * transform different json objects to our format
 */
export var transformers = {
// example:
// screen(event) {
//   event.param3 = event.param1 + event.param2;
//   return event;
// }
};
export default transformers;
